import { motion } from "framer-motion"

const rooms = [
  {
    id: "homeandliving",
    name: "Home & Living",
    image: "/C1.png?height=600&width=800",
    url: "/shoproduct/furniture",
  },
  {
    id: "lighting",
    name: "Lighting",
    image: "/lighting.png?height=600&width=800",
    url: "/shoproduct/furniture/lighting",
  },
  {
    id: "dining",
    name: "Dining",
    image: "/C3.png?height=600&width=800",
    url: "/shoproduct/decor",
  },
  {
    id: "study",
    name: "Study",
    image: "/C4.png?height=600&width=800",
    url: "/shoproduct/furniture",
  },
  {
    id: "outdoors",
    name: "Outdoors",
    image: "/C5.png?height=600&width=800",
    url: "/shoproduct/decor",
  },
]

export default function RoomGalleries() {
  const handleRoomClick = (room) => {
    window.open(room.url, '_blank')
  }

  return (
    <section className="mobile-section-padding bg-white py-24">
      <div className="container mx-auto px-4">
        <motion.h2
          className="mobile-heading-xl mobile-element-spacing mb-4 text-center font-serif text-3xl font-light md:text-4xl"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
        >
          Curate by Space
        </motion.h2>

        <motion.p
          className="mx-auto mb-16 max-w-2xl text-center text-muted-foreground"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          Discover our collections tailored to each space in your home.
        </motion.p>

        <div className="room-gallery-mobile grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {rooms.map((room, index) => (
            <motion.div
              key={room.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -10 }}
              className="cursor-pointer overflow-hidden"
              onClick={() => handleRoomClick(room)}
            >
              <div className="room-card-height-mobile relative h-80 overflow-hidden">
                <img
                  src={room.image || "/placeholder.svg"}
                  alt={room.name}
                  className="h-full w-full object-cover transition-transform duration-700 hover:scale-110"
                />

              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
} 